import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'Hakkımızda', href: '/hakkimizda' },
      { label: 'Özellikler', href: '/ozellikler' },
      { label: 'Demo', href: '/demo' },

      { label: 'İletişim', href: '/iletisim' }
    ],
    support: [
      { label: 'SSS', href: '/sss' },
      { label: 'Gizlilik Politikası', href: '/gizlilik' },
      { label: 'Kullanım Şartları', href: '/kullanim-sartlari' }
    ]
  };

  const socialLinks = [
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
        </svg>
      ),
      href: '#',
      label: 'Instagram'
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.791-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
      href: '#',
      label: 'Facebook'
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
      ),
      href: 'mailto:support@qrmenu.solutions',
      label: 'Email'
    }
  ];

  return (
    <footer className="footer" style={{
      background: 'linear-gradient(135deg, #1A1A2E 0%, #16213E 100%)',
      color: '#fff',
      padding: '80px 32px 40px 32px',
      position: 'relative',
      zIndex: 10,
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 20% 80%, rgba(197, 160, 106, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(197, 160, 106, 0.1) 0%, transparent 50%)',
        zIndex: 1
      }} />

      <div style={{ maxWidth: 1200, margin: '0 auto', position: 'relative', zIndex: 2 }}>
        {/* Main Content */}
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 48, marginBottom: 60 }}>
          {/* Brand Section */}
          <div className="footer-brand-section" style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <div className="footer-brand" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{
                width: 60,
                height: 60,
                borderRadius: 20,
                background: 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
              }}>
                <img
                  src="/qrmenu-small.webp"
                  alt="QR Menu Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <div>
                <h3 style={{ fontSize: 28, fontWeight: 700, margin: 0, color: '#fff' }}>
                  qrmenu<span style={{ color: '#C5A06A' }}>.solutions</span>
                </h3>
                <p style={{ fontSize: 14, color: '#B0B0B0', margin: 0 }}>Premium QR Çözümleri</p>
              </div>
            </div>
            <p className="footer-description" style={{ color: '#B0B0B0', lineHeight: 1.6, fontSize: 16, maxWidth: 400 }}>
              Restoranınızı dijital çağa taşıyın. Hızlı, güvenli ve şık QR menü çözümleriyle müşteri deneyimini mükemmelleştirin.
            </p>

          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([key, links]) => (
            <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <h4 style={{
                fontWeight: 600,
                fontSize: 18,
                margin: 0,
                color: '#fff',
                textTransform: 'capitalize'
              }}>
                {key === 'company' ? 'Şirket' : 'Destek'}
              </h4>
              {links.map(link => (
                <Link
                  key={link.label}
                  to={link.href}
                  style={{
                    color: '#B0B0B0',
                    textDecoration: 'none',
                    fontSize: 16,
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => (e.target as HTMLAnchorElement).style.color = '#C5A06A'}
                  onMouseLeave={(e) => (e.target as HTMLAnchorElement).style.color = '#B0B0B0'}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          ))}
        </div>


        {/* Social Links */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 24,
          marginBottom: 40
        }}>
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: 50,
                height: 50,
                borderRadius: 12,
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#C5A06A',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseEnter={(e) => {
                const target = e.target as HTMLAnchorElement;
                target.style.background = '#C5A06A';
                target.style.color = '#1A1A2E';
                target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                const target = e.target as HTMLAnchorElement;
                target.style.background = 'rgba(255,255,255,0.1)';
                target.style.color = '#C5A06A';
                target.style.transform = 'translateY(0)';
              }}
              aria-label={social.label}
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Bottom Bar */}
        <div style={{
          paddingTop: 24,
          borderTop: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#B0B0B0',
          fontSize: 14,
          flexWrap: 'wrap',
          gap: 16
        }}>
          <span>© {currentYear} qrmenu.solutions. Tüm hakları saklıdır.</span>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
            <span>Türkiye'de ❤️ ile yapıldı | v2.0.1</span>
            <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#B0B0B0' }}></span>
            <a
              href="https://metinhan.net"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#B0B0B0',
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#C5A06A'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#B0B0B0'}
            >
              Website by metinhan.net
            </a>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (max-width: 768px) {
            .footer {
              padding: clamp(40px, 10vw, 60px) 16px clamp(24px, 6vw, 32px) 16px !important;
            }
            
            .footer > div {
              max-width: 100% !important;
            }

            /* Force single column grid on mobile */
            footer.footer > div > div.footer-grid {
              grid-template-columns: 1fr !important;
              gap: 24px !important;
              margin-bottom: 32px !important;
            }
            
            /* Also target by position */
            .footer > div > div:first-child {
              grid-template-columns: 1fr !important;
              gap: clamp(24px, 6vw, 32px) !important;
              margin-bottom: clamp(32px, 8vw, 40px) !important;
            }

            /* Logo and brand name - keep inline on mobile */
            .footer-brand {
              flex-direction: row !important;
              align-items: center !important;
              gap: 12px !important;
              margin-bottom: 32px !important;
              width: 100% !important;
              display: flex !important;
              min-height: 60px !important;
            }

            .footer-brand-section {
              gap: 16px !important;
              display: flex !important;
              flex-direction: column !important;
            }

            /* Description text - force space below brand */
            .footer-description {
              margin-top: 0 !important;
              padding-top: 16px !important;
              margin-bottom: 0 !important;
              font-size: 14px !important;
              line-height: 1.5 !important;
              max-width: 100% !important;
              width: 100% !important;
              display: block !important;
              clear: both !important;
            }

            .footer-brand + p {
              margin-top: 0 !important;
            }

            .footer-brand h3 {
              font-size: 18px !important;
              line-height: 1.2 !important;
              margin: 0 !important;
            }

            .footer-brand p {
              font-size: 11px !important;
              margin: 0 !important;
            }
            
            .footer h3 {
              font-size: clamp(20px, 5.5vw, 24px) !important;
            }
            
            .footer p {
              font-size: clamp(14px, 3.8vw, 16px) !important;
            }
            
            .footer h4 {
              font-size: clamp(16px, 4.5vw, 18px) !important;
            }
            
            .footer a {
              font-size: clamp(14px, 3.8vw, 16px) !important;
            }
            
            .footer > div > div:last-child {
              gap: clamp(12px, 3vw, 16px) !important;
              margin-bottom: clamp(24px, 6vw, 32px) !important;
            }
            
            .footer > div > div:last-child > a {
              width: clamp(40px, 10vw, 50px) !important;
              height: clamp(40px, 10vw, 50px) !important;
            }
            
            .footer > div > div:last-child > a > svg {
              width: clamp(18px, 4.5vw, 20px) !important;
              height: clamp(18px, 4.5vw, 20px) !important;
            }
            
            .footer > div > div:last-child:last-of-type {
              flex-direction: column !important;
              text-align: center !important;
              gap: clamp(8px, 2vw, 12px) !important;
            }
            
            .footer > div > div:last-child:last-of-type > span {
              font-size: clamp(12px, 3vw, 14px) !important;
            }
            
            .footer > div > div:first-child > div:first-child > div:first-child {
              width: clamp(48px, 12vw, 60px) !important;
              height: clamp(48px, 12vw, 60px) !important;
            }
          }
          
          @media (max-width: 480px) {
            .footer {
              padding: clamp(32px, 8vw, 48px) 12px clamp(20px, 5vw, 24px) 12px !important;
            }
            
            .footer > div > div:first-child {
              gap: 20px !important;
            }
            
            .footer h3 {
              font-size: 18px !important;
            }
            
            .footer p {
              font-size: 13px !important;
            }
            
            .footer h4 {
              font-size: 15px !important;
            }
            
            .footer a {
              font-size: 13px !important;
            }
            
            .footer > div > div:last-child > a {
              width: 40px !important;
              height: 40px !important;
            }
            
            .footer > div > div:last-child > a > svg {
              width: 16px !important;
              height: 16px !important;
            }
            
            .footer > div > div:last-child:last-of-type > span {
              font-size: 11px !important;
            }
            
            .footer > div > div:first-child > div:first-child > div:first-child {
              width: clamp(40px, 10vw, 48px) !important;
              height: clamp(40px, 10vw, 48px) !important;
            }

            /* Text overflow fixes */
            .footer h3,
            .footer p,
            .footer span {
              word-wrap: break-word !important;
              overflow-wrap: break-word !important;
              max-width: 100% !important;
            }

            .footer > div {
              max-width: 100vw !important;
              overflow-x: hidden !important;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;